import apiClient from './api';

export interface JournalEntryDetailDto {
  entryDetailId: number;
  lineNumber: number;
  accountId: number;
  accountCode: string;
  accountName: string;
  accountNameAr?: string;
  debit: number;
  credit: number;
  costCenterId?: number;
  costCenterCode?: string;
  costCenterName?: string;
  description?: string;
  notes?: string;
}

export interface JournalEntryDto {
  journalEntryId: number;
  entryNumber: string;
  entryDate: string;
  entryTypeId: number;
  entryType: string;
  status: string;
  sourceType?: string;
  sourceDocumentId?: number;
  supplierInvoiceNumber?: string;
  description?: string;
  descriptionAr?: string;
  notes?: string;
  fiscalPeriodId?: number;
  fiscalPeriodName?: string;
  totalDebit: number;
  totalCredit: number;
  createdBy: number;
  createdByName?: string;
  createdDate: string;
  postedDate?: string;
  details: JournalEntryDetailDto[];
}

export interface CreateJournalEntryDetailDto {
  lineNumber: number;
  accountId: number;
  debit: number;
  credit: number;
  costCenterId?: number;
  description?: string;
  notes?: string;
}

export interface CreateJournalEntryDto {
  entryTypeId: number;
  entryNumber?: string;
  entryDate: string;
  fiscalPeriodId?: number;
  sourceType?: string;
  sourceDocumentId?: number;
  description?: string;
  descriptionAr?: string;
  notes?: string;
  details: CreateJournalEntryDetailDto[];
}

export interface UpdateJournalEntryDetailDto {
  entryDetailId?: number;
  lineNumber: number;
  accountId: number;
  debit: number;
  credit: number;
  costCenterId?: number;
  description?: string;
  notes?: string;
}

export interface UpdateJournalEntryDto {
  journalEntryId: number;
  entryDate: string;
  entryType?: string;           // ✅ إضافة
  fiscalYearId?: number;         // ✅ إضافة
  fiscalPeriodId?: number;
  sourceType?: string;           // ✅ إضافة
  sourceDocumentId?: number;     // ✅ إضافة
  description?: string;
  descriptionAr?: string;
  notes?: string;
  details: UpdateJournalEntryDetailDto[];
}

class JournalEntriesService {
  private baseUrl = '/JournalEntries';

  async getAll(): Promise<JournalEntryDto[]> {
    const response = await apiClient.get(this.baseUrl);
    return Array.isArray(response.data) ? response.data : [];
  }

  async getById(id: number): Promise<JournalEntryDto> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async getNextEntryNumber(entryTypeId: number): Promise<string> {
    const response = await apiClient.get(`${this.baseUrl}/next-number/${entryTypeId}`);
    return response.data;
  }

  async checkDuplicate(entryNumber: string): Promise<boolean> {
    const response = await apiClient.get(`${this.baseUrl}/check-duplicate/${entryNumber}`);
    return response.data.exists;
  }

  async create(data: CreateJournalEntryDto): Promise<JournalEntryDto> {
    const response = await apiClient.post(this.baseUrl, data);
    return response.data;
  }

  async update(id: number, data: UpdateJournalEntryDto): Promise<JournalEntryDto> {
    const response = await apiClient.put(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async post(id: number): Promise<void> {
    await apiClient.post(`${this.baseUrl}/${id}/post`);
  }

  async unpost(id: number): Promise<void> {
    await apiClient.post(`${this.baseUrl}/${id}/unpost`);
  }
}

export const journalEntriesService = new JournalEntriesService();